import { queries } from "lib/build/dashboards/shared";

import { useLastEventValueByQuery } from "src/features/events";

export function useAddress(): string | undefined {
	const value = useLastEventValueByQuery<{
		postCode: string;
		city: string;
		addressLineOne: string;
	}>(queries.address);
	if (value === undefined) {
		return undefined;
	}
	const { postCode, city, addressLineOne } = value;
	return `${postCode} ${city}, ${addressLineOne}`;
}
